jQuery(window).scroll(function () {
  var windowSize = jQuery(window).width();
  var distanceFromTop = jQuery(document).scrollTop();
  var headerHeight = jQuery(".header").outerHeight();
  // if (windowSize >= 1024) {
  //   if (distanceFromTop >= 200) {
  //     jQuery(".accessibility-bar").addClass("invisible-opacity");
  //   } else {
  //     jQuery(".accessibility-bar").removeClass("invisible-opacity");
  //   }
  // } else {
  //   // jQuery(".accessibility-bar").removeClass("hide");
  // }
});

jQuery(document).ready(function () {
  // var windowSize = jQuery(window).width();
  //var distanceFromTop = jQuery(document).scrollTop();
  //var headerHeight = jQuery(".header").outerHeight();
  var windowSize = jQuery(window).width();
  if (windowSize < 1024) {
    jQuery(".accessibility-bar").addClass("hide");
  } else {
    jQuery(".accessibility-bar").removeClass("hide");
  }


  jQuery("button.icon-accessibility").on("click", function (e) {
    if (jQuery(".accessibility-bar.hide")[0]) {
      jQuery(".accessibility-bar").removeClass("hide");
      jQuery("button.icon-accessibility").addClass("applied");
      jQuery("#contrastToggle").focus();
      jQuery(this).attr("aria-expanded", "true");
    } else {
      jQuery("button.icon-accessibility").removeClass("applied");
      jQuery(".accessibility-bar").addClass("hide");
      jQuery(this).attr("aria-expanded", "false");
    }
  });

  jQuery("#contrastToggle").on("click", function (e) {
    if (jQuery("#contrastToggle.applied")[0]) {
      jQuery("body").removeClass("contrast");
      jQuery("#contrastToggle").removeClass("applied");
      jQuery.removeCookie("accessibility_contrast", {
        path: "/"
      });
      jQuery(this).attr("aria-expanded", "false");
      jQuery(this).attr("data-message", "High contrast on");
    } else {
      jQuery("body").addClass("contrast");
      jQuery("#contrastToggle").addClass("applied");
      jQuery.cookie("accessibility_contrast", "true", {
        path: "/",
        expires: 365
      });
      jQuery(this).attr("aria-expanded", "true");
      jQuery(this).attr("data-message", "High contrast off");
    }
  });

  jQuery("#easyreadingToggle").on("click", function (e) {
    if (jQuery("#easyreadingToggle.applied")[0]) {
      jQuery("body").removeClass("easyreading");
      jQuery("#easyreadingToggle").removeClass("applied");
      jQuery.removeCookie("accessibility_easyreading", {
        path: "/",
        expires: 365
      });
      jQuery(this).attr("aria-expanded", "false");
      jQuery(this).attr("data-message", "Easy reading on");
    } else {
      jQuery("body").addClass("easyreading");
      jQuery("#easyreadingToggle").addClass("applied");
      jQuery.cookie("accessibility_easyreading", "true", {
        path: "/",
        expires: 365
      });
      jQuery(this).attr("aria-expanded", "true");
      jQuery(this).attr("data-message", "Easy reading off");

    }
  });

  if (jQuery.cookie("accessibility_contrast")) {
    jQuery(".accessibility-bar a.contrast").addClass("applied");
    jQuery("body").addClass("contrast");
  }

  if (jQuery.cookie("accessibility_easyreading")) {
    jQuery(".accessibility-bar #easyreadingToggle").addClass("applied");
    jQuery("body").addClass("easyreading");
  }

  // jQuery('a[target="_blank"').attr('title','Opens in a new window');
  // jQuery('a[target="_blank"').attr('aria-label', 'Opens in a new window');
  jQuery('a[target="_blank"]').each(function () {
    var ariaLabel = jQuery(this).attr('aria-label');
    var linkText = jQuery.trim(jQuery(this).text()); // Get the text inside the link and trim whitespace

    if (ariaLabel) {
      // Append the text if an aria-label already exists
      jQuery(this).attr('aria-label', ariaLabel + ' (Opens in a new window)');
    } else if (linkText) {
      // Add a new aria-label using the link text if no aria-label exists
      jQuery(this).attr('aria-label', linkText + ' (Opens in a new window)');
    } else {
      // If no text, just add the default aria-label
      jQuery(this).attr('aria-label', 'Opens in a new window');
    }
  });


  jQuery("#cookie-law-info-bar a, .cli-modal-content a").on("keypress", function (e) {
    if ((e.keyCode ? e.keyCode : e.which) == 13) {
      jQuery(this).trigger("click");
    }
  });



  var findInsiders = function (elem) {

    var tabbable = elem.find('select, input, textarea, button, a').filter(':visible');

    var firstTabbable = tabbable.first();
    var lastTabbable = tabbable.last();
    /*set focus on first input*/
    firstTabbable.focus();

    /*redirect last tab to first input*/
    lastTabbable.on('keydown', function (e) {
      if ((e.which === 9 && !e.shiftKey)) {
        e.preventDefault();
        firstTabbable.focus();
      }
    });

    /*redirect first shift+tab to last input*/
    firstTabbable.on('keydown', function (e) {
      if ((e.which === 9 && e.shiftKey)) {
        e.preventDefault();
        lastTabbable.focus();
      }
    });

    /* allow escape key to close insiders div */
    elem.on('keyup', function (e) {
      if (e.keyCode === 27) {
        elem.hide();
        jQuery('.mobile-menu-container button.close-button').click();
      };
    });
  };

  jQuery("button.hamburger-box").on("click", function (e) {
    findInsiders(jQuery('.mobile-menu-container nav'));
  });

  jQuery("header nav li.menu-item-has-children ul.sub-menu").focusin(function (e) {
    jQuery(document).keyup(function (e) {
      if (e.key === "Escape") {
        jQuery("nav.show-for-medium > ul > li:nth-child(3) a").focus();
      }
    });
    // console.log("inside");
  });


});